<template>
  <div :class="isPopup ? 'popup' : ''">
    <van-loading v-show="loading" class="loading">

    </van-loading>
    <div class="job-detail">
      <div class="top-info">
        <div class="title ellipsis line2">{{job.name}}</div>
        <div v-if="isPopup" class="go-detail" @click="goDetail">职位详情</div>
      </div>
      <div class="labels">
        <div class="label">
          <icon-svg class="icon-label" name="location"></icon-svg>
          <span class="ellipsis line1 work-city"> {{job.work_city}} </span>
        </div>
        <span class="bar"></span>
        <div class="label">
          <icon-svg class="icon-label" name="education"></icon-svg>

          <span class="ellipsis line1"> {{job.education | educationText}}</span>

        </div>
        <span class="bar"></span>
        <div class="label">
          <icon-svg class="icon-label" name="category"></icon-svg>
          <span class="ellipsis line1"> {{job.work_type | workTypeText}} </span>
        </div>
      </div>
      <div class="scroll-div" id="scroll-div">

        <div class="release-time">{{job.updatetime | formatDate_}} 发布</div>
        <div class="card-info">
          <van-row type="flex">
            <van-col span="12"> <span class="info-label">职位类型</span> <span class="info-value ellipsis line1">{{job.recruitment_type === 'SOCIAL' ? '社招' : '校招'}}</span></van-col>
            <van-col span="12"> <span class="info-label">工作年限</span> <span class="info-value ellipsis line1">{{job.work_years}}</span></van-col>
            <van-col span="12"> <span class="info-label">招聘人数</span> <span class="info-value ellipsis line1">{{job.number}}人</span></van-col>
            <van-col span="12"> <span class="info-label">学历要求</span> <span class="info-value ellipsis line1">{{job.education | educationText}}</span></van-col>
          </van-row>
        </div>
        <div class="sub-title">工作职责</div>
        <div class="detail" v-html="job.duty">{{}}</div>

        <div class="sub-title">工作要求</div>
        <div class="detail">{{job.requirement}}</div>

        <div class="card-info company-info">
          <div class="top">
            <div class="icon">
              <img src="../../../assets/images/jobs/company-logo.png" alt="">
            </div>
            <div class="title">
              <div class="name">卫宁健康科技股份有限公司</div>
              <div class="info">
                <span>已上市</span>
                <div class="dot"></div>
                <span>1000-9999人</span>
              </div>
            </div>
          </div>
          <div class="bottom">
            卫宁健康科技集团股份有限公司成立于1994年，是国内专注于医疗健康信息化的上市公司，致力于提供医疗健康卫生信息化解决方案，不断提升人们的就医体验和健康水平。卫宁健康通过持续的技术创新，自主研发适应不同应用场景的产品与解决方案，业务覆盖智慧医院、区域卫生、基层卫生、公共卫生、医疗保险、健康服务等领域，是中国医疗健康信息行业具有竞争力的整体产品、解决方案与服务供应商。
          </div>
        </div>
        <div class="qrcode">
          <img class="" src="../../../assets/images/jobs/qrcode.png" alt="">
        </div>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="collect" @click="onCollect">
        <icon-svg class="icon-collect" :name="job.collection_flag ? 'collect_on': 'collect'"></icon-svg>{{job.collection_flag ? '已收藏' : '收藏'}}
      </div>
      <div v-if="canApply" class="btn confirm" @click="onApply"> {{ btnText }} </div>
      <div v-else class="btn offline"> {{ btnText }} </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import cookies from "@/libs/util.cookies";
import { Toast } from "vant";
import util from "../../../libs/util";
export default {
  name: "JobDetail",
  props: {
    isPopup: {
      Type: Boolean,
      default: false,
    },
    hasResume: {
      Type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jobId: "",
      loading: true,
      job: {
        createtime: "",
        updatetime: "",
        education: "",
        name: "",
        number: "",
        recruitment_type: "",
        duty: "",
        requirement: "",
        work_city: "",
        work_type: "",
        work_years: "",
        resume_flag: false,
        // 岗位状态：ONLINE可投递，OFFLINE已下线
        status: "OFFLINE",
        // 未投递 or 已投递
        delivery_flag: false,
        // 已收藏or未收藏
        collection_flag: false,
      },
      user_id: cookies.get("uid"),
    };
  },
  computed: {
    ...mapState("dic", ["educationType", "recruitType", "positionType"]),
    canApply() {
      return this.job.status === "Online" && !this.job.delivery_flag;
    },
    btnText() {
      if (this.job.status === "Offline") {
        return "该岗位已下线";
      } else if (this.job.delivery_flag) {
        return "已投递";
      } else {
        return "投递岗位";
      }
    },
  },
  created() {
    // 获取职位详情
    if (!this.isPopup) {
      this.jobId = this.$route.params.jobId;
      this.refreshJobDetail(true);
    }
  },
  mounted() {},
  methods: {
    ...mapMutations("header", ["setLabelText"]),
    // popup面板 -> 跳转职位详情
    goDetail() {
      this.$router.push({
        name: "JobDetail",
        params: {
          jobId: this.jobId,
        },
      });
    },
    scrollTop() {
      this.$nextTick(() => {
        const scrollDiv = document.getElementById("scroll-div");
        scrollDiv.scrollTop = 0;
      });
    },
    // 刷新页面职位信息
    refreshJobDetail(needLoading = false) {
      if (needLoading) this.loading = true;
      this.scrollTop();
      this.$api
        .GET_POSITION_DETAIL(this.jobId, { user_id: this.user_id })
        .then((res) => {
          this.job = res;

          if (!this.isPopup) {
            this.$nextTick(() => {
              const isSocial = this.job.recruitment_type === "SOCIAL";
              // 设置Header标签文字（校招 or 社招）
              this.setLabelText(isSocial ? "社会招聘" : "校园招聘");

              // 配置微信分享
              const wxTitle = isSocial ? "卫宁健康期待您的加入" : "加入我们，实现价值";
              const wxDesc = isSocial ? "正在热招：" + this.job.name : "卫宁健康2027校园招聘\r\n" + this.job.name;

              const shareParam = {
                title: wxTitle,
                desc: wxDesc,
                link: process.env.VUE_APP_BASEURL + `#/job/detail/${this.jobId}`,
                imgUrl: process.env.VUE_APP_SHARE_IMG_URL,
              };
              util.initWXSdk(shareParam);
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 投递
    onApply() {
      // 获取用户简历
      if (!this.job.resume_flag) {
        //不存在简历时， 先完善简历
        Toast("请先完善简历！");
        this.$router.push({ path: "/resume" });
      } else {
        const params = {
          position_id: this.jobId,
          user_id: this.user_id,
        };
        this.$api.POSITION_DELIVERY(params).then(() => {
          this.refreshJobDetail();
          Toast("投递成功");
        });
      }
    },

    // 收藏
    onCollect() {
      const params = {
        position_id: this.jobId,
        user_id: this.user_id,
      };
      if (this.job.collection_flag) {
        // 收藏
        this.$api.POSITION_COLLECT_DELETE(params).then(() => {
          this.refreshJobDetail();
          Toast("取消收藏");
        });
      } else {
        // 收藏
        this.$api.POSITION_COLLECT(params).then(() => {
          this.refreshJobDetail();
          Toast("收藏成功");
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.job-detail {
  padding-top: 18px;
  padding-bottom: 58px;
}
.top-info {
  padding: 0 20px;
  padding-bottom: 12px;
  align-self: flex-start;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    line-height: 33px;
    margin-right: 20px;
    text-align: left;
  }

  .go-detail {
    width: 60px;
    min-width: 60px;
    margin-right: 30px;
    transform: translateY(1.5px);
    text-decoration: underline;
    color: #2e5dd2;
    font-size: 12px;
  }
}
.labels {
  padding: 0 20px;
  padding-bottom: 10px;
  display: flex;
  height: 20px;
  align-items: center;
  .label {
    font-size: 14px;
    color: #666666;
    display: flex;
    align-items: center;
    .icon-label {
      width: 15px;
      height: 15px;
      margin-right: 6px;
    }
    span {
      height: 20px;
      line-height: 20px;
    }
    span.work-city {
      max-width: 75px;
    }
  }
  .bar {
    width: 1px;
    height: 15px;
    margin: 0 10px;
    background: #f1f4f6;
  }
}
.scroll-div {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .release-time {
    font-size: 12px;
    color: #999999;
    line-height: 17px;
    margin-bottom: 14px;
  }

  .card-info {
    padding: 6px 15px;
    background: #f8fafb;
    border-radius: 10px;
    margin-bottom: 25px;
    .van-col {
      padding: 5px;
      display: flex;
      align-items: center;
      font-size: 14px;
      .info-label {
        color: #999999;
      }
      .info-value {
        margin-left: 10px;
        font-weight: bold;
        color: #333333;
        max-width: 70px;
      }
    }
  }

  .sub-title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 14px;
  }

  .detail {
    font-size: 15px;
    color: #666666;
    word-wrap: break-word;
    word-break: normal;
    white-space: pre-wrap;
    text-align: left;
    max-width: 100%;
    line-height: 28px;
    margin-bottom: 25px;
  }

  .company-info {
    padding: 15px;
    .top {
      display: flex;
      .icon {
        margin-right: 12px;
        img {
          // width: 44px;
          height: 44px;
        }
      }
    }
    .title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .name {
        font-size: 16px;
        font-weight: bold;
        color: #2e5dd2;
      }

      .info {
        display: flex;
        align-items: center;
        margin-top: 5px;
        font-size: 12px;
        color: #999999;

        .dot {
          margin: 0px 8px;
          height: 2px;
          width: 2px;
          background: #999999;
        }
      }
    }

    .bottom {
      margin-top: 14px;
      font-size: 15px;
      color: #666666;
      // white-space: pre-wrap;
      text-align: left;
      line-height: 28px;
    }
  }
  .qrcode {
    width: 125px;
    height: 118px;
    align-self: center;
    img {
      width: 125px;
      height: 118px;
    }
  }
}
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 20px;
  .collect {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #666666;
  }

  .icon-collect {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }

  .btn {
    height: 44px;
    width: 250px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    border-radius: 25px;
    border: 1px solid #eaedf0;
    background: linear-gradient(90deg, #3871ff 0%, #2e5dd2 100%);
    // line-height: 44px;
  }

  .confirm {
    color: #ffffff;
  }

  .offline {
    color: rgba(255, 255, 255, 0.3);
  }
}

::v-deep .van-loading {
  width: 100%;
  height: 100%;
  background: white;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.popup {
  overflow: hidden;

  .scroll-div {
    height: 354px;
    max-height: 48vh;
    overflow-y: scroll;
  }
}
</style>
